import { Button } from '@iwoca/orion';
import { Trans } from '@lingui/react/macro';
import { useAmplitude } from 'hooks/useAmplitude';
import { TApplication } from 'lendingApi/applications.types';
import { Link } from 'react-router-dom';
import { checkApplicationIsComplete } from 'utils/application/application.helpers';
import { APPLICATION_STATUS_VALUE } from 'utils/applications/applications.config';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';
import styles from '../ApplicationStatusCell.module.css';
import { ContinueApplicationButton } from '../ContinueApplicationButton/ContinueApplicationButton';

type TProps = {
  cannotCreateApp: boolean;
  cannotUploadDocs: boolean;
  application: TApplication;
  documentsPath: string;
};

export const OpenButtonOrLabel = ({
  cannotCreateApp,
  cannotUploadDocs,
  application,
  documentsPath,
}: TProps) => {
  const { trackEvent } = useAmplitude();
  const applicationId = application.application_uid;
  const stateKey = application.customer.state_key;
  const applicationIsComplete = checkApplicationIsComplete(application);

  const handleOpenApplicationTracking = () => {
    trackEvent(AMPLITUDE_EVENTS.dashboardCTAClicked, {
      Status: 'Open',
    });
  };

  if (!applicationIsComplete) {
    if (cannotCreateApp) {
      return (
        <span className={styles.noPermissionStatus}>
          <Trans>App in progress</Trans>
        </span>
      );
    }

    if (!stateKey) {
      return null;
    }

    return (
      <ContinueApplicationButton
        stateKey={stateKey}
        applicationId={applicationId}
      />
    );
  }

  if (applicationIsComplete) {
    if (cannotUploadDocs) {
      return (
        <span className={styles.noPermissionStatus}>
          <Trans>Docs required</Trans>
        </span>
      );
    }
    return (
      <Link to={documentsPath}>
        <Button
          variant="action"
          size="small"
          onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
            e.stopPropagation();
            handleOpenApplicationTracking();
          }}
        >
          <Trans>Docs required</Trans>
        </Button>
      </Link>
    );
  }

  return (
    <span className={styles.actionableStatus}>
      {APPLICATION_STATUS_VALUE(application.status)}
    </span>
  );
};
